import styled from "styled-components";

export const DistributorReportContainer = styled.div`
  display: flex;
`;
